export const OTP_RESEND_COUNTDOWN_SECONDS = 120;
